// 环形图
export default {
  name: '环形图',
  type: 'pie',
  option: (data) => ({
    tooltip: {
      trigger: 'item',
    },
    legend: {
      top: '5%',
      left: 'center',
    },
    series: [
      {
        name: data.y[0].name,
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        // itemStyle: {
        //   borderRadius: 10,
        //   borderColor: '#fff',
        //   borderWidth: 2,
        // },
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '40',
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: data.x.map((label, index) => ({
          value: data.y[0].data[index],
          name: label,
        })),
      },
    ],
  }),
};
